import React from 'react';
import { useSelector } from 'react-redux';
import { RouteProps, Redirect, Route } from 'react-router';

import { generateRoute } from '@services/navigation-service';
import { getIsLoggedIn } from '@state/system';

const PrivateRoute = ({ children, ...rest }: RouteProps) => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const next = rest?.location?.pathname;
  const search = next ? `?next=${next}` : '';

  return (
    <Route {...rest}>
      {isLoggedIn ? (
        children
      ) : (
        <Redirect
          to={{
            pathname: generateRoute('/'),
            search,
          }}
        />
      )}
    </Route>
  );
};

export default PrivateRoute;
